import { Link } from 'react-router-dom';
import { FaQuoteLeft } from 'react-icons/fa';
import { TESTIMONIES } from '../data/testimonies';
import { EVENT } from '../data/eventInfo';
import RegisterCTA from '../components/RegisterCTA';

export default function Testimonies() {
  return (
    <>
      <section className="page-hero">
        <div className="container narrow">
          <p className="page-hero-eyebrow">Testimonies</p>
          <h1>
            <span className="nowrap">Real Stories.</span>{' '}
            <span className="nowrap">Real Marriages.</span>
          </h1>
          <p className="page-hero-sub">
            What we hear again and again from couples who've come home from the weekend
            different than they arrived.
          </p>
        </div>
      </section>

      <section className="section testimonies-full">
        <div className="container">
          <div className="testimony-list">
            {TESTIMONIES.map(t => (
              <div key={t.id} className="testimony-card testimony-full">
                <FaQuoteLeft className="quote-icon" />
                <p className="testimony-quote">{t.quote}</p>
                <p className="testimony-name">— {t.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section register">
        <div className="container">
          <h2>Your Story Could Be Next</h2>
          <p className="subtitle">Come, walk with God alongside your spouse. Join us in {EVENT.shortLocation}.</p>
          <RegisterCTA className="cta-button" />
          <div style={{ marginTop: '1.5rem' }}>
            <Link to="/" className="text-link">← Back to home</Link>
          </div>
        </div>
      </section>
    </>
  );
}
